import React, { useRef, useState } from "react";
import api from "@/lib/api";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";

export async function uploadFile(file, category = "general") {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/files/upload?category=${category}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // {id, original_filename, content_type, ...}
}

export default function UploadButton({ onUploaded, category = "general", accept, label, className = "", testId }) {
  const ref = useRef();
  const [loading, setLoading] = useState(false);
  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const doc = await uploadFile(file, category);
      onUploaded(doc);
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };
  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={loading} data-testid={testId}
        className={`inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg border border-border hover:border-primary transition-colors ${className}`}>
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {label}
      </button>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} />
    </>
  );
}
